'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTheme = exports.getLanguage = exports.setTheme = exports.setLanguage = exports.getPreference = exports.setPreference = exports.getPreferences = exports.setPreferences = exports.deletePreferences = undefined;

var _util = require('@its/util');

var PREFERENCES = 'preferences';

var deletePreferences = exports.deletePreferences = function deletePreferences() {
  localStorage.removeItem(PREFERENCES);
};

var setPreferences = exports.setPreferences = function setPreferences(preferences) {
  localStorage.setItem(PREFERENCES, JSON.stringify(preferences));
};

var getPreferences = exports.getPreferences = function getPreferences() {
  var preferences = localStorage.getItem(PREFERENCES);
  return preferences ? JSON.parse(preferences) : null;
};

var setPreference = exports.setPreference = function setPreference(preference, value) {
  var preferences = getPreferences();
  var newPreference = {};
  newPreference[preference] = value;
  if (preferences) {
    preferences = (0, _util.merge)(preferences, newPreference);
  } else {
    preferences = newPreference;
  }
  setPreferences(preferences);
};

var getPreference = exports.getPreference = function getPreference(preference) {
  var preferences = getPreferences();
  return preferences ? preferences[preference] : null;
};

var setLanguage = exports.setLanguage = setPreference.bind(null, 'language');
var setTheme = exports.setTheme = setPreference.bind(null, 'theme');

var getLanguage = exports.getLanguage = getPreference.bind(null, 'language');
var getTheme = exports.getTheme = getPreference.bind(null, 'theme');


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/util/preferences.js
 ** module id = 178
 ** module chunks = 0
 **/